import type { Except } from '@festina-life/core'
import { type ComponentProps, type ReactNode, useState } from 'react'

import { RawTextInput } from '../../forms/textInput/RawTextInput'
import { Icon } from '../../structure/icon/Icon'
import { Stack } from '../../structure/stack/Stack'
import { Typography } from '../../structure/typography/Typography'
import { SortableTable } from '../sortableTable/SortableTable'

type Props<T extends WeakKey> = {
  title?: ReactNode
  actions?: ReactNode
} & Except<ComponentProps<typeof SortableTable<T>>, 'searchCriteria'>

export function SortableTableSearch<T extends WeakKey>({
  title,
  actions,
  ...restProps
}: Props<T>) {
  const [search, setSearch] = useState('')

  return (
    <>
      {/* For layout to work both directly inside a cardbody and anywhere else we need to conditionally add margin */}
      {/* It would be simpler to wrap this entire component in a stack, but we cannot as it would break the table-inside-cardbody-styling */}
      <Stack className="items-end not-[[data-amaze-cardbody]>&]:mb-1.5">
        {title && (
          <Typography
            id="sortable-search"
            as="h3"
            weight="bold"
            intensity="primary"
          >
            {title}
          </Typography>
        )}
        <Stack className="items-center ms-auto">
          {actions}
          <RawTextInput
            value={search}
            onChange={(e) => {
              setSearch(e.currentTarget.value)
            }}
            addOnProps={{
              element: <Icon name="MagnifyingGlass" />,
            }}
            aria-describedby="sortable-search"
            className="w-40!"
          />
        </Stack>
      </Stack>
      <SortableTable searchCriteria={search} {...restProps} />
    </>
  )
}
